import { CLOSE_REASONS, isKnownCloseReason, normalizeClosePayload } from '@Sage/iframe-embed';

import { EntityCrudActions } from 'actions';
import { ENTITY_CRUD_CLOSE } from 'constants/ActionTypes';
import { ACTIVITIES } from 'constants/Entities';
import Context from 'managers/Context';
import { getLiteral } from 'utils/getLiteral';
import { ensureRoute } from 'utils/routes';
import { errorToast, infoToast, successToast } from 'utils/toast';

const refreshEntityList = (dispatch, getState, entity, manager) => {
    let pageSize = null;
    if (manager?.getCustomPageSize) {
        pageSize = manager.getCustomPageSize();
    }

    dispatch(Context.actions.EntityListActions.init(entity, true, pageSize || null));
};

const closeEmbeddedCrud = ({ dispatch, onCloseProp }) => {
    if (onCloseProp) {
        onCloseProp();
        return;
    }

    dispatch(EntityCrudActions.close(false));
};

const closeEmbeddedCrudAfterDetailSave = ({ dispatch, getState, manager, onCloseProp }) => {
    if (onCloseProp) {
        onCloseProp();
        return;
    }

    dispatch({ type: ENTITY_CRUD_CLOSE, tabs: getState().entityDetail?.tabs });
    manager?.afterCrudClose?.();
};

const openSavedEntityDetail = ({ dispatch, entity, entityCrud, getState, ssmEntityId }) => {
    const state = getState();
    const shouldDoHiddenRefresh =
        state.entityDetail.isOpen && entityCrud?.entity !== ACTIVITIES.entity;

    if (shouldDoHiddenRefresh) {
        dispatch(Context.actions.EntityDetailActions.hiddenRefresh(entity, ssmEntityId));
        return;
    }

    dispatch(
        Context.actions.EntityDetailActions.open(
            entity,
            ssmEntityId,
            false,
            null,
            true,
            false,
            null,
            entityCrud?.isFromTab,
            entityCrud?.avoidRedirects,
            entityCrud?.extraInfo?.origin || null,
        ),
    );

    if (!entityCrud?.isModal && !entityCrud?.avoidRedirects) {
        const isMapOpen = window.location.href.includes('/map/');
        const route = isMapOpen
            ? `${entity.route}/map/${ssmEntityId}`
            : `${entity.route}/${ssmEntityId}`;
        ensureRoute(route);
    }
};

export const handleEmbedCloseOutcome = ({
    dispatch,
    entity,
    entityCrud,
    getState,
    manager,
    onCloseProp,
    payload = {},
}) => {
    const closePayload = normalizeClosePayload(payload);
    const reason = isKnownCloseReason(closePayload.reason) ? closePayload.reason : null;
    const ssmEntityId = closePayload.entityId;
    const hasSsmEntityId = ssmEntityId != null && ssmEntityId !== '';

    switch (reason) {
        case CLOSE_REASONS.SAVED: {
            if (closePayload.suppressHostToast !== true) {
                successToast({
                    text: closePayload.message || getLiteral('title_toast_success'),
                });
            }

            if (hasSsmEntityId) {
                openSavedEntityDetail({
                    dispatch,
                    entity,
                    entityCrud,
                    getState,
                    ssmEntityId,
                });
                closeEmbeddedCrudAfterDetailSave({ dispatch, getState, manager, onCloseProp });
            } else {
                closeEmbeddedCrud({ dispatch, onCloseProp });
                refreshEntityList(dispatch, getState, entity, manager);
            }

            return;
        }
        case CLOSE_REASONS.SUBMITTED: {
            infoToast({
                text: closePayload.message || getLiteral('label_info'),
            });
            closeEmbeddedCrud({ dispatch, onCloseProp });
            refreshEntityList(dispatch, getState, entity, manager);
            return;
        }
        case CLOSE_REASONS.FAILED: {
            errorToast({
                text: closePayload.message || getLiteral('error_connection'),
            });
            closeEmbeddedCrud({ dispatch, onCloseProp });
            return;
        }
        default:
            closeEmbeddedCrud({ dispatch, onCloseProp });
    }
};
